import * as utils from './utils.js';

// namespace
var tableBuilder = {};



export function getRelevantFields(selectedSearchType, activeset){

  let tableOptions = getOptions(null, null, selectedSearchType, [], activeset);
  let fieldsList = new Array();
  let fieldsDetails = tableOptions["fields"];

  for (var i=0; i<fieldsDetails.length; i++)
  {
    fieldsList.push(fieldsDetails[i]["key"]);
  }

  return fieldsList;
}


// get the DataTable table options for the results table to be built
export function getOptions(sparqlQuery, keyword, selectedSearchType, selectFieldsOfAdvancedSearch, activeset){

    // default options

    var tableOptions = {
              "fields": [], 
              "sortsettings": [null, false]
      };

    // set the right DataTable columns, given the query

    if (selectedSearchType == 'simple_search' && activeset == 'anw')
      tableOptions = {
              "fields": [
                //{key: 'lemId', label: 'ANW lemmaId', sortable: true, sortDirection: 'desc', 
                //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'lemma', label: 'ANW lemma', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key])+" (<a href='http://anw.ivdnt.org/article/"+item[key]+"' target='_blank'>link</a>)";} }, 
                //{key: 'writtenForm', label: 'Ontolex writtenRepresentation', sortable: true, sortDirection: 'desc'},
                {key: 'definition', label: 'Definitie', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key]);} },
                {key: 'definitionComplement', label: 'Complement bij definitie', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
              ], 
              "sortsettings": ['lemma', false]
      };

    else if (selectedSearchType == 'simple_search' && activeset == 'celex')
      tableOptions = {
              "fields": [
                //{key: 'lemmaId', label: 'Celex lemmaId', sortable: true, sortDirection: 'desc', 
                //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'lemma', label: 'Celex lemma', sortable: true, 
                  formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key]);} }, 
                //{key: 'wordformId', label: 'Celex WoordvormId', sortable: true, sortDirection: 'desc', 
                //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'wordform', label: 'Celex Woordvorm', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key]);} },
                {key: 'pronunciation', label: 'Uitspraak', sortable: true, 
                  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'number', label: 'Getal', sortable: true, 
                  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'gender', label: 'Geslacht', sortable: true, 
                  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },                

                //{key: 'subLemmaId', label: 'Celex sublemmaId', sortable: true, sortDirection: 'desc', 
                //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
                {key: 'subLemmata', label: 'Morfologie', sortable: true, 
                  formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
              ], 
              "sortsettings": ['lemma', false]
      };

    else if (selectedSearchType == 'simple_search' && activeset == 'duelme_mwe') 
      tableOptions = {
              "fields": [              
              {key: 'lemma', label: 'Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key]);} },
              {key: 'lemmaPos', label: 'POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'parts', label: 'Analyse', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
            ], 
              "sortsettings": ['lemma', false]
      };


    else if (selectedSearchType == 'simple_search' && activeset == 'duelme_celex') 
      tableOptions = {
              "fields": [
              {key: 'exampleSentence', label: 'Voorbeeld', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]));} },
              {key: 'lemma', label: 'Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], item[key]);} },
              {key: 'wordform', label: 'Woordvorm', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'gender', label: 'Geslacht', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'number', label: 'Getal', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
            ], 
              "sortsettings": ['lemma', false]
      };

    else if (selectedSearchType == 'simple_search' && activeset == 'molex') 
      tableOptions = {
              "fields": [
              //{key: 'lemEntryId', label: 'LemmaId', sortable: true, sortDirection: 'desc', 
              //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'lemma', label: 'Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]))+" (<a href='https://woordenlijst.org/#/?q="+item[key]+"' target='_blank'>link</a>)";} },
              {key: 'lemPos', label: 'Lemma POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              //{key: 'wordformId', label: 'WoordvormId', sortable: true, sortDirection: 'desc', 
              //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'wordform', label: 'Woordvorm', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]));} },
              {key: 'hyphenation', label: 'Afbreking', sortable: true, sortDirection: 'desc' },
              {key: 'wordformPos', label: 'Woordvorm POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'Gender', label: 'Geslacht', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'Number', label: 'Getal', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
            ], 
              "sortsettings": ['lemma', false]
      };

    else if (selectedSearchType == 'simple_search' && activeset == 'diamant') 
      tableOptions = {
              "fields": [
              //{key: 'entryId', label: 'entryId', sortable: true, sortDirection: 'desc', 
              //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'lemma', label: 'Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]));} },
              //{key: 'senseId', label: 'senseId', sortable: true, sortDirection: 'desc', 
              //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              //{key: 'senseDefId', label: 'senseDefId', sortable: true, sortDirection: 'desc', 
              //  formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'sensedefDefinitionText', label: 'Definitie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]));} },
              {key: 'syndefDefinitionText', label: 'Definitie Syn', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword['main'], utils.formatThat(item[key]));} },
              {key: 'witnessYearFrom', label: 'Tekstgetuige vanaf', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'witnessYearTo', label: 'Tekstgetuige tot', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} }
            ], 
              "sortsettings": ['lemma', false]
      };

    else if (selectedSearchType == 'advanced_search' && activeset == 'definition')
      tableOptions = {
             "fields": [
              {key: 'anwLemma', label: 'ANW Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} }, 
              //{key: 'writtenForm', label: 'Ontolex writtenRepresentation', sortable: true, sortDirection: 'desc'},
              {key: 'anwDefinition', label: 'ANW Definitie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} },
              {key: 'anwDefinitionComplement', label: 'Complement bij ANW definitie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },

              {key: 'diamantLemma', label: 'DiaMaNT Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], utils.formatThat(item[key]) );} },
              {key: 'diamantDefinition', label: 'DiaMaNT Definitie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], utils.formatThat(item[key]) );} },
              {key: 'diamantSynDefinition', label: 'DiaMaNT Definitie Syn', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], utils.formatThat(item[key]) );} },
              {key: 'relevance', label: 'Relevantie', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return item[key];} }
            ], 
              "sortsettings": ['relevance', true]  // sort by relevance desc
      }

      else if (selectedSearchType == 'advanced_search' && activeset == 'paradigm')
        tableOptions = {
             "fields": [
              {key: 'celexLemma', label: 'Celex Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} }, 
              {key: 'celexWordform', label: 'Celex Woordvorm', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} },
              {key: 'celexPronunciation', label: 'Celex Uitspraak', sortable: true, 
              formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'celexGender', label: 'Celex Geslacht', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'celexNumber', label: 'Celex Getal', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },            

              
              {key: 'molexLemma', label: 'Molex Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], utils.formatThat(item[key]));} },
              {key: 'molexLemPos', label: 'Molex Lemma POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'molexWordform', label: 'Molex Woordvorm', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], utils.formatThat(item[key]));} },
              {key: 'molexHyphenation', label: 'Molex Afbreking', sortable: true, sortDirection: 'desc' },
              {key: 'molexWordformPos', label: 'Molex Woordvorm POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'molexGender', label: 'Molex Geslacht', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'molexNumber', label: 'Molex Getal', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'relevance', label: 'Relevantie', sortable: true, sortDirection: 'desc', 
                  formatter: (value, key, item) => {return item[key];} }
            ], 
              "sortsettings": ['celexLemma', false]  // sort by celexLemma asc (because we want to see full paradigms; sorting by relevance would break that)
      }


      else if (selectedSearchType == 'advanced_search' && activeset == 'attestations')
        tableOptions = {
             "fields": [
              
              {key: 'duelMeLemma', label: 'DuelMe Lemma', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} }, 
              {key: 'duelMeGender', label: 'DuelMe Geslacht', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'duelMeNumber', label: 'DuelMe Getal', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },              
              {key: 'duelMeExample', label: 'DuelMe Voorbeeld', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} },
              {key: 'duelMeAttestation', label: 'DuelMe Attestatie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} },
              {key: 'relevance', label: 'Relevantie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return item[key];} }
              
            ], 
              "sortsettings": ['relevance', true]  // sort by relevance desc
      }

      else if (selectedSearchType == 'advanced_search' && activeset == 'mwe')
        tableOptions = {
             "fields": [
              
              {key: 'duelMeMweLemma', label: 'DuelMe Lemma (verbinding)', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} }, 
              {key: 'duelMeMwePos', label: 'DuelMe POS', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.highlightThis(keyword[key], item[key]);} },
              {key: 'duelMeMweParts', label: 'DuelMe Analyse', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return utils.formatThat(item[key]);} },
              {key: 'relevance', label: 'Relevantie', sortable: true, sortDirection: 'desc', 
                formatter: (value, key, item) => {return item[key];} }
              
            ], 
              "sortsettings": ['relevance', true]  // sort by relevance desc
      }

      else if (selectedSearchType == 'expert_search')
      {
        // extract the search fields names out of the sparql query
        // (replace the \n\r by spaces so we don't need to take too many things into account...)
        sparqlQuery = sparqlQuery.replace(/\n\r/g, ' ').trim();
        var selectPart = sparqlQuery.substring( sparqlQuery.toLowerCase().indexOf('select') + 'select'.length ).trim();

        // remove 'distinct', otherwise it will be seen as a column name
        if (selectPart.toLowerCase().match("distinct "))
          selectPart = selectPart.replace(/distinct /gi, "");

        // the select part should be bordered by 'where' or 'from':
        // take the first one we encounter and consider it to be the border
        var allInArray = [];
        var firstWhere = utils.regexIndexOf(selectPart.toLowerCase(), "\\bwhere\\b");
        var firstFrom = utils.regexIndexOf(selectPart.toLowerCase(), "\\bfrom\\b");

        // of course, keep only values above -1 (useless otherwise!)
        if (firstWhere>-1) allInArray.push(firstWhere);
        if (firstFrom>-1) allInArray.push(firstFrom);

        // get the smallest index (t.i. first occurence of 'where' or 'from')
        allInArray = allInArray.sort(function sortNumber(a,b) {return a - b;}); 
        var cutOfFrom = allInArray[0];
        selectPart = selectPart.substring(0, cutOfFrom).trim();

        // remove extra spaces and cut SELECT string into its separate field names
        selectPart = selectPart.replace(/ +/g, ' ');
        var extractedFields = selectPart.split(' ');

        
        // build the tableOptions
        var fieldsArr = [];
        for (var i=0; i<extractedFields.length; i++)
        { 
          var oneField = extractedFields[i];
          
          fieldsArr.push({
            key: oneField.replace('?', '').trim(),
            label: oneField.replace('?', '').trim(),
            sortable: true, 
            sortDirection: 'desc'
          });
        }

        tableOptions = {
              "fields": fieldsArr, 
              "sortsettings": [null, false]
        }
      }


    // Make sure we only fetch the columns the user has chosen!
         
    if (selectedSearchType == 'advanced_search')  // advanced search only!
    {
    for (var oneField in tableOptions["fields"])
          {
            var oneKey = tableOptions["fields"][oneField]["key"];              
            if ( typeof selectFieldsOfAdvancedSearch[oneKey] != 'undefined' && selectFieldsOfAdvancedSearch[oneKey] == false )
              delete tableOptions["fields"][oneField];
          }
    }
    
    return tableOptions;
  };

export default tableBuilder;


// WEBPACK FOOTER //
// ./src/js/tableBuilder.js